module.exports = __webpack_public_path__ + "static/media/video.f6c2de42.jpg";